import { render, staticRenderFns } from "./OnboardingGeneral.vue?vue&type=template&id=70dbfe42&scoped=true"
import script from "./OnboardingGeneral.vue?vue&type=script&lang=js"
export * from "./OnboardingGeneral.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OnboardingGeneral.vue?vue&type=style&index=1&id=70dbfe42&prod&scoped=true&lang=css"
import style2 from "./OnboardingGeneral.vue?vue&type=style&index=2&id=70dbfe42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dbfe42",
  null
  
)

export default component.exports